const specialValues = ['65535', '4294967295'];

export default specialValues;
